import { useAuth0 } from "@auth0/auth0-react";

const useAuth = () => {
  const { loginWithRedirect, isAuthenticated, isLoading, user, logout } = useAuth0();

  const loginWithRedirectLoc = () => {
    loginWithRedirect({
      authorizationParams: {
        connection: "google-oauth2",
        access_type: "offline",
        scopes:
          "https://www.googleapis.com/auth/youtube.forcessl,https://www.googleapis.com/auth/youtube,https://www.googleapis.com/auth/yt-analytics.readonly",
        approvalPrompt: "force",
        scope: "openid profile email phone https://www.googleapis.com/auth/youtube.forcessl https://www.googleapis.com/auth/youtube https://www.googleapis.com/auth/yt-analytics.readonly"
      }
    });
  };

  const logoutWithRedirect = () => {
    logout({
        logoutParams: {
          returnTo: window.location.origin
        }
      }
    );
  };
  // loginWithRedirect, isAuthenticated, isLoading, user

  return {
    loginWithRedirect: loginWithRedirectLoc, isAuthenticated, isLoading, user, logout: logoutWithRedirect
  };
};
export default useAuth;